import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Link, useSearchParams } from "react-router-dom";
import { getCustomerWalletHistory } from "../../services/user";
import { startLoader, stopLoader } from "../../libs/utils";
import CustomTable from "../../components/CustomTable";
import { useEffect, useState } from "react";
import moment from "moment";
import Swal from "sweetalert2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const LINK_LEFT_STYLE = { marginLeft: "4px", fontSize: "18px" };

const WalletHistory = (props) => {
  const [searchParams] = useSearchParams();

  const timestamp = searchParams.get("timestamp");
  const identifier = searchParams.get("identifier");
  const userEmail = searchParams.get("email");

  const { walletHistory: propsWalletHistory } = props || {};

  const [walletHistory, setWalletHistory] = useState(propsWalletHistory || []);

  const walletHistoryColumns = [
    { id: "storename", label: "Store Name" },
    { id: "amount", label: "Amount" },
    { id: "transaction_type", label: "Cashback Type" },
    {
      id: "transaction_status_description",
      label: "Cashback Status",
      minWidth: 50,
    },
    {
      id: "entry_timestamp",
      label: "Entry Time",
      minWidth: 100,
      format: (value) => (value ? moment(value).format("MMM D, YYYY") : ""),
    },
    {
      id: "is_pending",
      label: "Pending",
      minWidth: 100,
      format: (value) => (value ? "Yes" : "No"),
    },
    { id: "remark", label: "Remark", minWidth: 100 },
    { id: "maturity_date", label: "Maturity Date", minWidth: 100 },
    {
      id: "expiry_time",
      label: "Expiry Date",
      minWidth: 100,
      format: (value) => (value ? moment(value).format("MMM D, YYYY") : ""),
    },
    {
      id: "action_date",
      label: "Transaction Date",
      minWidth: 100,
      format: (value) => (value ? moment(value).format("MMM D, YYYY") : ""),
    },
    { id: "spent_amount", label: "Spent Amount", minWidth: 100 },
    {
      id: "created_by",
      label: "Issued By",
      minWidth: 100,
      format: (value) => (value ? value : "SYSTEM"),
    },
  ];

  const fetchWalletHistory = async (timestamp) => {
    startLoader();
    const response = await getCustomerWalletHistory(timestamp, userEmail);
    const { success, data, error } = response || {};
    if (success) {
      setWalletHistory(data);
      stopLoader();
      return;
    }
    Swal.fire({
      title: "Oops",
      text: error?.message || "Something went wrong",
      icon: "warning",
      confirmButtonText: "Ok",
    });
    stopLoader();
  };

  useEffect(() => {
    if (timestamp) {
      fetchWalletHistory(timestamp);
    }
  }, [timestamp]);

  useEffect(() => {
    if (propsWalletHistory) {
      setWalletHistory(propsWalletHistory);
    }
  }, [propsWalletHistory]);

  const timestampMoment = moment(parseInt(timestamp));
  const year = timestampMoment.isValid()
    ? timestampMoment.year()
    : moment().year();

  return (
    <Box sx={{ ml: "4", pt: "14 !important", pb: "5", px: 3 }}>
      {timestamp && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "25px",
            marginTop: "20px",
            gap: "16px",
          }}
        >
          <Link to={`/app/user?identifier=${identifier}`}>
            <ArrowBackIcon
              fontSize="large"
              color="secondary"
              sx={{ background: "#040721", p: 1, borderRadius: "50%" }}
            />
          </Link>
          <Typography
            variant="h5"
            component="h5"
            fontWeight={"bold"}
            color={"#3d3d3d"}
          >
            {`Cumulative Cashback for Year ${year}`}
          </Typography>
        </div>
      )}
      {walletHistory.length > 0 ? (
        <Box sx={{ background: "#ffffff", p: 2, mb: 4, pb: 4 }}>
          <CustomTable
            data={walletHistory}
            columns={walletHistoryColumns}
            defaultRowPerPage={50}
          />
        </Box>
      ) : (
        <div>No data found</div>
      )}
    </Box>
  );
};

export default WalletHistory;
